import { useEffect, useState } from "react";
import { getAccessTokenSilently } from "utils/AuthUtils";
import { UserAdministration } from "api";
import { getUserName } from "api/user-administration/user-administration";
import FormMultiSelect from "components/Forms/FormMultiSelect";
import { useAuth } from "context";

/**
 * (Load users) and offer a multi-select of them.
 * @param {*} param0
 * @returns
 */
export default function FormSelectUser({ label, name, ...props }) {
  const { getAccessTokenSilently } = useAuth();
  const [users, setUsers] = useState([]);

  const PAGE_SIZE = 1000;

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      UserAdministration.getUsers(`size=${PAGE_SIZE}`).then((usersWrappedPage) => {
        console.log("usersWrappedPage!", usersWrappedPage);
        setUsers(usersWrappedPage.page.content);
      });
    });
  }, [getAccessTokenSilently]);

//   console.log("users!", users);
  const userOptions = users?.map
    ? users.map((user) => ({
        value: user.email,
        // Name isnt always unique, plus it isnt a secure identifier, so we must show email
        label: getUserName(user) + " (" + user.email + ")",
      }))
    : [];

  return <FormMultiSelect label={label} name={name} options={userOptions} {...props} />;
}
